export const HOME_CONTAINER_CORE_LIST = [
    {
        title: '「π+」建站平台',
        subTitle: '一体式网站搭建平台，可实现「零」代码建站服务。',
        link: '',
        imageUrl: '',
        imageBgType: 'frozen-dreams'
    },
    {
        title: '「π·meta」多元管理系统',
        subTitle: '集成众多管理功能于一体的管理系统，实现一站多元的管理模式。',
        link: '',
        imageUrl: '',
        imageBgType: 'winter-neva'
    },
    {
        title: '「π·custom」专属定制',
        subTitle: '专属业务，专属定制。精心打造完美契合使用的场景项目。',
        link: '',
        imageUrl: '',
        imageBgType: 'cochiti-lake'
    },
    // {
    //     title: '推陈出新',
    //     subTitle: '为您既有的软件项目添加新功能进行分析及实施，满足您的个性化需求。',
    //     link: '',
    //     imageUrl: '',
    //     imageBgType: 'cochiti-lake'
    // },
]